import React from 'react';
import SoftPhoneActiveCall, { SoftPhoneIncoming } from '@/components/softphone/SoftPhoneCallViews';
import SoftPhoneIdleView from '@/components/softphone/SoftPhoneIdleView';
import { SoftPhoneFloatingButton, SoftPhoneMinimizedBar, SoftPhoneHeader } from '@/components/softphone/SoftPhoneChrome';
import { useSoftPhone } from '@/components/softphone/useSoftPhone';

export default function SoftPhone() {
  const sp = useSoftPhone();

  // Shown for all authenticated users (including clients)
  if (!sp.user) return null;

  const inCall = sp.view === 'active' || sp.view === 'ringing';
  const floating = (
    <SoftPhoneFloatingButton view={sp.view} onToggle={() => { sp.setIsOpen(!sp.isOpen); sp.setIsMinimized(false); }} />
  );

  if (!sp.isOpen) return floating;

  if (sp.isMinimized && inCall) {
    return (
      <>
        {floating}
        <SoftPhoneMinimizedBar
          view={sp.view} duration={sp.duration} isRecording={sp.isRecording}
          name={sp.selectedContact?.full_name || sp.currentCall?.caller_name || 'Appel'}
          onExpand={() => sp.setIsMinimized(false)}
        />
      </>
    );
  }

  const handleClose = () => {
    if (sp.view === 'idle' || sp.view === 'incoming') sp.setIsOpen(false);
    else sp.setIsMinimized(true);
  };

  return (
    <>
      {floating}
      <div data-testid="softphone-panel"
        className="fixed bottom-24 right-6 z-50 w-[360px] bg-slate-900 rounded-2xl shadow-2xl border border-slate-700/50 overflow-hidden"
        style={{ maxHeight: '540px' }}>
        <SoftPhoneHeader view={sp.view} isRecording={sp.isRecording} onMinimize={() => sp.setIsMinimized(true)} onClose={handleClose} />

        {inCall && (
          <SoftPhoneActiveCall
            view={sp.view} duration={sp.duration}
            selectedContact={sp.selectedContact} currentCall={sp.currentCall}
            isMuted={sp.isMuted} setIsMuted={sp.setIsMuted}
            isSpeakerOff={sp.isSpeakerOff} setIsSpeakerOff={sp.setIsSpeakerOff}
            isRecording={sp.isRecording} isStaff={sp.isStaff}
            onToggleRecording={sp.toggleRecording} onEndCall={sp.endCall}
          />
        )}

        {sp.view === 'incoming' && (
          <SoftPhoneIncoming currentCall={sp.currentCall} onAnswer={sp.answerCall} onDecline={sp.declineCall} />
        )}

        {sp.view === 'idle' && <SoftPhoneIdleView sp={sp} />}
      </div>
    </>
  );
}
